import React from 'react';
import Table from 'react-bootstrap/Table';


function ReadingEmotions(props: any) {
	   
  return (
   <div className="masthead">
			<h1>How To Read People & Their Emotions</h1>
			
      <div className="separator"></div>
			<p>This lesson is still under development. Please come back later!</p>
			
			<Table striped borderless hover responsive className="course-table">
				<thead>
					<tr><th className="course-table-header">Module 2: The Importance Of Emotions</th></tr>
				</thead>

				<tbody className="course-table-body">
					<tr> <td> <a href="/core-emotions">What are our core emotions?</a></td> </tr>
					<tr> <td> <a href="/emotional-literacy">How can you become more emotionally literate?</a></td> </tr>
				</tbody>
			</Table>

			<div className="input-group">
        <div className="input-group-append content-btn-box">
          <a href="/ei-course" className="content-btn">Back to the course</a>
        </div>
      </div>
      
      <div className="separator"></div>
      <div className="separator"></div>
   </div>
  )
}
export default ReadingEmotions;

